// REMEMBER TO UPDATE environment.ts

export const environment = {
  production: true,
  api_url: '/api/v1',
  wifi_disabled: false,
  admin_email: 'corey@lowercaseproductions.com',
  // version: code_version,
  google_client_id: '722825241230-eephdv7379upl0psuokdud57tl63udrc.apps.googleusercontent.com', // updated: lcp-website-client-1
  google_client_secret: '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', // updated: lcp-website-client-1
  

  paypal_base: 'http://sandbox.paypal.com',

  // paypal_client_id: 'ATSK4W0ZTcygJjkoQqcSzfNEua6zSxxxxxxxxxxx' // OAK PARK LIVE - handled in index.prod.html

  contentful: {
    spaceId: 'ertyhukhlvrl', // lcp
    accessToken: '-8jByx7qnH9lWSMTeyew26HGK7YE7s7pQu8t8cdTxHk', // lcp
    environment: 'master', // replace with your environment ID if needed - master is the default production environment in Contentful
  },

  mailjet: {
    private: '79d347ea632a76b6e63e73b68e82c492',
    public: '7e9dc9efb1c1ec3a395712e167521a4b'
  }
}
